<template>
    <el-breadcrumb separator-class="el-icon-caret-right">
        <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
            <span :class="[levelList.length - 1 !==index ? 'strong':'thin']" v-text="item.meta.title"></span>
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
    export default {
        name: "Breadcrumb",
        data(){
            return{
                levelList: [],
            }
        },
        created(){
            this.getBreadcrumb();
        },
        watch: {
            $route() {
                this.getBreadcrumb();
            },
        },
        methods: {
            getBreadcrumb() {
                // only show routes with meta.title
                let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
                this.levelList = matched.filter(item => item.meta && item.meta.title);
            },
        },
    }
</script>

<style scoped>
    .el-breadcrumb {
        min-height: 40px;
        line-height: 40px;
        padding-left: 50px;
    }
    .strong {
        color: #303133;
    }
    .thin{
        color: #7f8fa1;
    }
</style>
